import cn from "classnames";
import styles from "../Front.module.sass";
import cusHomePage from "../../../i11/CustomizeHomePage";

import { Link } from "react-router-dom";
import { useUser } from "../../../context";

const BrandBoxNavbar = ({ image, name }) => {
	const { locale, setLocal } = useUser();

	return (
		<div>
			<div className={styles.language}>
				<button
					style={{
						fontWeight: locale === "en" && "bold",
					}}
					onClick={() => setLocal("en")}
				>
					international (EN)
				</button>
				<button
					style={{
						fontWeight: locale === "it" && "bold",
					}}
					onClick={() => setLocal("it")}
				>
					italiano (IT)
				</button>
			</div>

			<div className={styles.navbar}>
				{image ? (
					<img
						src={image}
						alt="__logo__"
						className={styles.image}
						loading="lazy"
					/>
				) : (
					<div>Logo</div>
				)}
				<div className={styles.row}>
					<Link
						className={cn(styles.link, name === "home" && styles.under)}
						to="/customize/home"
					>
						{cusHomePage[locale].home}
					</Link>
					<Link
						className={cn(styles.link, name === "token-store" && styles.under)}
						to="/customize/token-store"
					>
						{cusHomePage[locale].token_store}
					</Link>
					<Link
						className={cn(
							styles.link,
							name === "com-marketplace" && styles.under
						)}
						to="/customize/com-marketplace"
					>
						{cusHomePage[locale].com_marketplace}
					</Link>
				</div>
				<div style={{ margin: "auto 0" }}>{cusHomePage[locale].login}</div>
			</div>
		</div>
	);
};

export default BrandBoxNavbar;
